/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import zaincashLogo from "../../../assets/zaincash.png";
import qicardLogo from "../../../assets/qicard.png";

export const payments = [
  {
    nameAr: "زين كاش",
    nameEn: "ZainCash",
    img: zaincashLogo,
    descAr:
      "واحدة من أشهر المحافظ الإلكترونية في العراق، تتيح الدفع والتحويل بسهولة.",
    descEn:
      "A leading e-wallet in Iraq offering easy payment and transfer services.",
  },
  {
    nameAr: "كي كارد",
    nameEn: "QiCard",
    img: qicardLogo,
    descAr: "بطاقة الدفع الإلكتروني العراقية المدعومة من عدة بنوك محلية.",
    descEn: "Iraqi smart payment card supported by many local banks.",
  },
];
